import { Deserializable } from '../../../models/protocols/deserializable';
import { Address } from '../../../models/users/dto/address';

export class FiduciarySubmissionOrganizationEntity implements Deserializable {
  public id!: string;
  public legalFiduciaryOrganizationEntityId!: number | null;
  public contactFirstName!: string | null;
  public contactLastName!: string | null;
  public email!: string;
  public name!: string;
  public phoneNumber!: string;
  public phoneNumberCountryCode!: string;
  public address!: Address | null;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;
    if (this.address) {
      this.address = Deserialize.instanceOf(Address, this.address);
    }
  }
}
